import SEOHead from '../../components/feature/SEOHead';
import WorksheetTimelineHero from './components/WorksheetTimelineHero';
import PassosTimeline from './components/PassosTimeline';
import PraticaTimeline from './components/PraticaTimeline';
import CompromissoTimeline from './components/CompromissoTimeline';
import CTATimeline from './components/CTATimeline';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const worksheetLinhaTempoSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Worksheet Linha do Tempo PNL — Guia Completo',
    description: 'Guia completo da técnica Linha do Tempo de PNL para ressignificar o passado, viver plenamente o presente e criar um futuro extraordinário.',
    image: `${SITE_URL}/og-worksheet-linha-tempo.png`,
    totalTime: 'PT45M',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Visualize Sua Linha do Tempo',
        text: 'Imagine uma linha que representa sua vida do passado ao futuro. Identifique onde está o passado, presente e futuro em relação ao seu corpo.'
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Identifique o Evento a Ressignificar',
        text: 'Escolha um evento do passado que ainda carrega emoções negativas ou limitantes que você deseja transformar.'
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'Flutue Acima da Linha',
        text: 'Mentalmente, eleve-se acima da sua linha do tempo para ter uma perspectiva dissociada e neutra do evento.'
      },
      {
        '@type': 'HowToStep',
        position: 4,
        name: 'Volte ao Evento Original',
        text: 'Viaje pela linha do tempo até o momento antes do evento acontecer, mantendo a perspectiva dissociada.'
      },
      {
        '@type': 'HowToStep',
        position: 5,
        name: 'Extraia os Aprendizados',
        text: 'Identifique as lições e recursos que você ganhou com aquela experiência, ressignificando o significado do evento.'
      },
      {
        '@type': 'HowToStep',
        position: 6,
        name: 'Retorne ao Presente Transformado',
        text: 'Volte ao presente pela linha do tempo, trazendo os aprendizados e deixando as emoções negativas no passado.'
      }
    ]
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Worksheet Linha do Tempo PNL | Guia Completo — Carta do Eu Futuro',
    url: `${SITE_URL}/worksheet-linha-tempo`,
    description: 'Worksheet completo da Linha do Tempo de PNL. Técnica para ressignificar o passado, viver plenamente o presente e criar um futuro extraordinário com clareza e intenção.',
    inLanguage: 'pt-BR',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Worksheet Linha do Tempo', item: `${SITE_URL}/worksheet-linha-tempo` },
      ],
    },
  }
];

export default function WorksheetLinhaTempoPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Worksheet Linha do Tempo PNL | Guia Completo — Carta do Eu Futuro"
        description="Worksheet completo da Linha do Tempo de PNL. Técnica para ressignificar o passado, viver plenamente o presente e criar um futuro extraordinário com clareza e intenção."
        keywords="worksheet linha do tempo, PNL, linha do tempo, ressignificar passado, desenvolvimento pessoal"
        canonical="/worksheet-linha-tempo"
        schema={worksheetLinhaTempoSchema}
      />
      <WorksheetTimelineHero />
      <PassosTimeline />
      <PraticaTimeline />
      <CompromissoTimeline />
      <CTATimeline />
    </div>
  );
}